import { queryOptions } from '@tanstack/react-query';
import { api } from '../api/client';
import type {
  Me, PeriodSummary, SubmissionDetail,
  AdminPeriodCard, AdminPeriodDetail, DraftPreview,
  FeeConfigResponse, UserResponse, CompanyResponse, AppConfigResponse, AuditLogPage,
} from './types';

export const meOptions = () =>
  queryOptions({ queryKey: ['me'], queryFn: () => api.get('me').json<Me>() });

export const periodsOptions = () =>
  queryOptions({ queryKey: ['periods'], queryFn: () => api.get('periods').json<PeriodSummary[]>() });

export const periodDetailOptions = (periodId: number) =>
  queryOptions({
    queryKey: ['periods', periodId],
    queryFn: () => api.get(`periods/${periodId}`).json<SubmissionDetail>(),
  });

export const adminPeriodsOptions = () =>
  queryOptions({ queryKey: ['admin', 'periods'], queryFn: () => api.get('admin/periods').json<AdminPeriodCard[]>() });

export const adminPeriodDetailOptions = (periodId: number) =>
  queryOptions({
    queryKey: ['admin', 'periods', periodId, 'detail'],
    queryFn: () => api.get(`admin/periods/${periodId}/detail`).json<AdminPeriodDetail>(),
  });

export const adminPeriodDraftPreviewOptions = (periodId: number) =>
  queryOptions({
    queryKey: ['admin', 'periods', periodId, 'draft-preview'],
    queryFn: () => api.get(`admin/periods/${periodId}/draft-preview`).json<DraftPreview>(),
  });

export const adminFeesOptions = () =>
  queryOptions({ queryKey: ['admin', 'fees'], queryFn: () => api.get('admin/fees').json<FeeConfigResponse[]>() });

export const adminUsersOptions = (status: 'ACTIVE' | 'INACTIVE' = 'ACTIVE') =>
  queryOptions({
    queryKey: ['admin', 'users', status],
    queryFn: () => api.get('admin/users', { searchParams: { status } }).json<UserResponse[]>(),
  });

export const adminCompaniesOptions = () =>
  queryOptions({ queryKey: ['admin', 'companies'], queryFn: () => api.get('admin/companies').json<CompanyResponse[]>() });

export const adminAppConfigOptions = () =>
  queryOptions({ queryKey: ['admin', 'app-config'], queryFn: () => api.get('admin/app-config').json<AppConfigResponse>() });

export const adminAuditLogOptions = (page: number, size = 50) =>
  queryOptions({
    queryKey: ['admin', 'audit-log', page, size],
    queryFn: () => api.get('admin/audit-log', { searchParams: { page, size } }).json<AuditLogPage>(),
  });
